module.exports = __webpack_public_path__ + "img/button_image10.0478d6b7.jpg";